import { render, staticRenderFns } from "./ProfileHeader.vue?vue&type=template&id=44fe67a0&scoped=true&"
import script from "./ProfileHeader.vue?vue&type=script&lang=js&"
export * from "./ProfileHeader.vue?vue&type=script&lang=js&"
import style0 from "./ProfileHeader.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./ProfileHeader.vue?vue&type=style&index=1&id=44fe67a0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44fe67a0",
  null
  
)

export default component.exports